<template>
  <b-modal
    ok-title="Zapisz"
    cancel-title="Anuluj"
    ok-variant="outline-primary"
    cancel-variant="outline-secondary"
    hide-header
    @ok="ok"
    v-model="localShow"
    @hide="
      $emit('hide');
      reset();
    "
  >
    <b-form>
      <b-form-group label="Nazwa harmonogramu">
        <b-input v-model="name"></b-input>
      </b-form-group>
      <div v-for="day of days" :key="day">
        <b-form-group>
          <div slot="label">
            {{ dayName[day] }}&nbsp;
            <b-checkbox class="pt-1 float-right" v-model="check[day]"></b-checkbox>
          </div>
          <b-row v-show="check[day]" class="w-100">
            <b-col cols="6">
              <time-select
                :disabled="!check[day]"
                @time="
                  value => {
                    startTime[day] = value;
                  }
                "
              ></time-select>
            </b-col>
            <b-col cols="6">
              <b-select :disabled="!check[day]" v-model="workTime[day]" :options="time"></b-select>
            </b-col>
          </b-row>
        </b-form-group>
      </div>
    </b-form>
    <span>
      Łączny czas pracy
      <span :class="{ 'text-danger': sum > 40 }">{{ sum }}</span>
    </span>
  </b-modal>
</template>
<script>
import TimeSelect from '@/components/TimeSelect.vue';
import { TimetableResource } from '@/resources/timetable.resource';

export default {
  components: { TimeSelect },
  props: ['show', 'timetable', 'toEdit'],
  data() {
    return {
      localShow: false,
      time: [
        { text: '0 godzin', value: 0 },
        { text: '1 godzina', value: 1 },
        { text: '2 godziny', value: 2 },
        { text: '3 godziny', value: 3 },
        { text: '4 godziny', value: 4 },
        { text: '5 godzin', value: 5 },
        { text: '6 godzin', value: 6 },
        { text: '7 godzin', value: 7 },
        { text: '8 godzin', value: 8 },
        { text: '9 godzin', value: 9 },
        { text: '10 godzin', value: 10 },
        { text: '11 godzin', value: 11 },
        { text: '12 godzin', value: 12 }
      ],
      dayName: { monday: 'Poniedziałek', tuesday: 'Wtorek', wednesday: 'Środa', thursday: 'Czwartek', friday: 'Piątek', saturday: 'Sobota', sunday: 'Niedziela' },
      days: ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'],
      check: undefined,
      startTime: undefined,
      workTime: undefined,
      checkDefault: { monday: true, tuesday: true, wednesday: true, thursday: true, friday: true, saturday: false, sunday: false },
      startTimeDefault: { monday: null, tuesday: null, wednesday: null, thursday: null, friday: null, saturday: null, sunday: null },
      workTimeDefault: { monday: 8, tuesday: 8, wednesday: 8, thursday: 8, friday: 8, saturday: 0, sunday: 0 },
      id: undefined,
      name: ''
    };
  },
  methods: {
    ok() {
      for (const day of this.days) {
        if (this.check[day]) {
          if (!Number.isInteger(this.startTime[day])) {
            const arr = this.startTime[day].split(':');
            this.startTime[day] = parseInt(arr[0], 10) * 60 + parseInt(arr[1], 10);
          }
          this.workTime[day] = this.workTime[day] * 60;
        } else {
          this.startTime[day] = null;
          this.workTime[day] = null;
        }
      }
      this.saveTimetable();
    },
    async saveTimetable() {
      const timetable = {
        name: this.name,
        monTime: this.workTime.monday,
        tueTime: this.workTime.tuesday,
        wedTime: this.workTime.wednesday,
        thuTime: this.workTime.thursday,
        friTime: this.workTime.friday,
        satTime: this.workTime.saturday,
        sunTime: this.workTime.sunday,
        ...this.startTime
      };
      try {
        if (this.id) {
          timetable.id = this.id;
          const data = await TimetableResource.update(this.id, this.name, this.workTime, this.startTime);
          this.$notify({ text: 'Pomyślnie edytowano harmonogram', title: 'Sukces!', type: 'success' });
          this.$emit('updated', timetable);
        } else {
          const data = await TimetableResource.create(this.name, this.workTime, this.startTime);
          this.$notify({ text: 'Pomyślnie dodano harmonogram', title: 'Sukces!', type: 'success' });
          this.$emit('created', timetable);
        }
        this.reset();
      } catch (error) {
        this.$notify({ text: 'Wystąpił błąd podczas dodawania harmonogramu', title: 'Błąd!', type: 'error' });
        console.warn(error);
      }
    },
    reset() {
      this.check = this.checkDefault;
      this.startTime = this.startTimeDefault;
      this.workTime = this.workTimeDefault;
      this.name = '';
      this.id = undefined;
    },
    setData(data) {
      this.name = data.name;
      this.id = data.id;
      if (data.monTime) {
        this.check.monday = true;
        this.workTime.monday = data.monTime / 60;
      }
      if (data.tueTime) {
        this.check.tuesday = true;
        this.workTime.tuesday = data.tueTime / 60;
      }
      if (data.wedTime) {
        this.check.wednesday = true;
        this.workTime.wednesday = data.wedTime / 60;
      }
      if (data.thuTime) {
        this.check.thursday = true;
        this.workTime.thursday = data.thuTime / 60;
      }
      if (data.friTime) {
        this.check.friday = true;
        this.workTime.friday = data.friTime / 60;
      }
      if (data.satTime) {
        this.check.saturday = true;
        this.workTime.saturday = data.satTime / 60;
      }
      if (data.sunTime) {
        this.check.sunday = true;
        this.workTime.sunday = data.sunTime / 60;
      }
    }
  },
  created() {
    this.reset();
  },
  computed: {
    sum() {
      let sum = 0;
      for (const day of this.days) {
        if (this.check[day]) {
          sum += this.workTime[day];
        }
      }
      return sum;
    }
  },
  watch: {
    show(val) {
      this.localShow = val;
      if (!val) {
        this.reset();
      }
    },
    toEdit(val) {
      if (val) {
        this.setData(val);
      }
    }
  }
};
</script>
<style></style>
